export default __webpack_public_path__ + "static/media/lock-nextsong.373e7916.png";